export const config = {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: '规则代码',
                align: 'center',
                prop: 'ruleCode',
                width: 120
            },
            {
                label: '规则名称',
                align: 'center',
                prop: 'ruleName',
                width: 120
            },
            {
                label: '条码位数',
                align: 'center',
                prop: 'codeNum',
                width: 120
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};